const relativeUrl = (url) => {
  try {
    return new URL(url).pathname;
  } catch (error) {
    return '#';
  }
};
export default relativeUrl;
